"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildGA4PackagingProductItem = exports.buildEecPackagingProduct = void 0;
const enums_1 = require("../enums");
const calculatePackagingProductIfrs_1 = require("./calculatePackagingProductIfrs");
const getPackagingProductId = (packaging) => {
    if ('variantId' in packaging && packaging.variantId) {
        return packaging.variantId;
    }
    if ('manufacturerSku' in packaging && packaging.manufacturerSku) {
        return packaging.manufacturerSku;
    }
    return '';
};
function buildEecPackagingProduct({ quantity, tenant, offsetShare, packaging, }) {
    const eecPrice = packaging.price.gross.amount;
    const eecProduct = {
        quantity,
        name: packaging.title,
        id: getPackagingProductId(packaging),
        price: eecPrice,
        metric9: null,
        metric10: null,
        category: '',
        variant: 'gift_wrap',
    };
    if (tenant !== undefined && quantity !== undefined && offsetShare !== undefined) {
        const metric5 = (0, calculatePackagingProductIfrs_1.calculatePackagingProductIfrs)({
            packaging,
            tenant,
            quantity,
            offsetShare,
        });
        eecProduct.metric5 = Number(metric5.toFixed(2));
    }
    return eecProduct;
}
exports.buildEecPackagingProduct = buildEecPackagingProduct;
const buildGA4PackagingProductItem = ({ quantity, tenant, offsetShare, packaging, }) => {
    const productItem = {
        item_id: getPackagingProductId(packaging),
        item_name: packaging.title,
        item_brand: '',
        price: packaging.price.gross.amount,
        price_category: enums_1.GA4PriceCategory.Regular,
        item_category: '',
        item_category2: '',
        item_category3: '',
        item_category4: '',
        item_variant: enums_1.Variant.GiftWrap,
        price_special: undefined,
        quantity,
    };
    if (tenant !== undefined && quantity !== undefined && offsetShare !== undefined) {
        const itemIfrs = (0, calculatePackagingProductIfrs_1.calculatePackagingProductIfrs)({
            packaging,
            tenant,
            quantity,
            offsetShare,
        });
        productItem.item_ifrs = Number(itemIfrs.toFixed(2));
    }
    return productItem;
};
exports.buildGA4PackagingProductItem = buildGA4PackagingProductItem;
//# sourceMappingURL=buildEecPackagingProduct.js.map